import React, { useRef, useState } from "react";

import Footer from "../Components/Footer";

import IndiaBoatsTopBar from "../Components/IndiaBoatsTopBar";
import PremiumNavbar from "../Components/PremiumNavbar";



const Gift = () => {

     const [selectedYacht, setSelectedYacht] = useState(null);
  const [showGiftModal, setShowGiftModal] = useState(false);
  const sliderRef = useRef(null);

  const [formData, setFormData] = useState({
    recipientName: '',
    yourName: '',
    occasion: 'Birthday',
    giftMessage: ''
  });

  const [showVoucherPreview, setShowVoucherPreview] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleOccasionSelect = (occ) => {
    setFormData(prev => ({
      ...prev,
      occasion: occ
    }));
  };

  const handlePreview = (e) => {
    e.preventDefault();
    setShowVoucherPreview(true);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitted(true);
  };

  const occasions = ['Birthday', 'Anniversary', 'Wedding', 'Proposal', 'Other'];

  const yachtsData = [
    {
      id: "yacht-1",
      name: "Bigger Sail Yachts",
      guests: "Up to 15 Guests",
      goodFor: "Couples, Family & VIP Celebrations",
      image: "assets/img/pyc1.JPG",
      tag: "Luxury Cruiser"
    },
    {
      id: "yacht-2",
      name: "Premium Yachts",
      guests: "Up to 8 Guests",
      goodFor: "Couples, Sunsets & Small Groups",
      image: "assets/img/pyc2.JPG",
      tag: "Sailing Yacht"
    },
    {
      id: "yacht-3",
      name: "Sail Boats",
      guests: "Up to 25 Guests",
      goodFor: "Friends, Family Parties & Events",
      image: "assets/img/pyc3.JPG",
      tag: "Catamaran"
    },
    {
      id: "yacht-4",
      name: "Compact Yachts",
      guests: "Up to 20 Guests",
      goodFor: "Anniversaries, Couples & Grand Parties",
      image: "assets/img/pyc4.JPG",
      tag: "Superyacht"
    },
    {
      id: "yacht-5",
      name: "Mid Size Yachts",
      guests: "Up to 6 Guests",
      goodFor: "Couples & Thrill-Seekers",
      image: "assets/img/pyc5.JPG",
      tag: "Speed Cruiser"
    }
  ];

  const scrollSlider = (direction) => {
    if (sliderRef.current) {
      const scrollAmount = sliderRef.current.clientWidth * 0.75;
      sliderRef.current.scrollBy({
        left: direction === 'next' ? scrollAmount : -scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  const handleGiftNow = (yacht) => {
    setSelectedYacht(yacht);
    setShowGiftModal(true);
  };

  return (
    <>
      <IndiaBoatsTopBar />
      <PremiumNavbar />

      {/* <section className="ib-gft-section">
      

      <div className="ib-gft-container">
        
       
        <div className="ib-gft-header">
          <div className="ib-gft-title-area">
            
            <h1 className="ib-gft-main-title">Select yacht experience as Gift</h1>
           
          </div>

          <div className="ib-gft-nav-group">
            <button 
              className="ib-gft-nav-btn" 
              onClick={() => scrollSlider('prev')} 
              aria-label="Previous Yacht"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="15 18 9 12 15 6"></polyline>
              </svg>
            </button>
            <button 
              className="ib-gft-nav-btn" 
              onClick={() => scrollSlider('next')} 
              aria-label="Next Yacht"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </button>
          </div>
        </div>

        {}
        <div className="ib-gft-slider-wrapper">
          <div className="ib-gft-slider" ref={sliderRef}>
            {yachtsData.map((yacht) => (
              <div className="ib-gft-card" key={yacht.id}>
                
                
                <div className="ib-gft-img-box">
                  <img 
                    src={yacht.image} 
                    alt={yacht.name} 
                    className="ib-gft-card-img" 
                    loading="lazy" 
                  />
                  
                </div>

                
                <div className="ib-gft-card-body">
                  <div>
                    <h3 className="ib-gft-yacht-name">{yacht.name}</h3>

                    
                    <div className="ib-gft-meta-list">
                      
                      
                      <div className="ib-gft-meta-item">
                        <div className="ib-gft-icon-wrapper">
                          <svg className="ib-gft-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                            <circle cx="9" cy="7" r="4"></circle>
                            <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                          </svg>
                        </div>
                        <div>
                          <span className="ib-gft-meta-label">Guest Capacity</span>
                          <span className="ib-gft-meta-value">{yacht.guests}</span>
                        </div>
                      </div>

                      
                      <div className="ib-gft-meta-item">
                        <div className="ib-gft-icon-wrapper">
                          <svg className="ib-gft-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l8.72-8.72 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
                          </svg>
                        </div>
                        <div>
                          <span className="ib-gft-meta-label">Good For</span>
                          <span className="ib-gft-meta-value">{yacht.goodFor}</span>
                        </div>
                      </div>

                    </div>
                  </div>

                  
                  <button 
                    className="ib-gft-btn" 
                    onClick={() => handleGiftNow(yacht)}
                  >
                    <svg className="ib-gft-btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="20 12 20 22 4 22 4 12"></polyline>
                      <rect x="2" y="7" width="20" height="5"></rect>
                      <line x1="12" y1="22" x2="12" y2="7"></line>
                      <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"></path>
                      <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"></path>
                    </svg>
                    Gift Now
                  </button>

                </div>

              </div>
            ))}
          </div>
        </div>

      </div>

      {}
      {showGiftModal && selectedYacht && (
        <div className="ib-gft-modal-overlay" onClick={() => setShowGiftModal(false)}>
          <div className="ib-gft-modal" onClick={(e) => e.stopPropagation()}>
            <button className="ib-gft-modal-close" onClick={() => setShowGiftModal(false)}>
              &times;
            </button>
            <h3 className="ib-gft-modal-title">Yacht Experience Selected</h3>
            <p className="ib-gft-modal-sub">
              You are gifting a luxury sailing voucher for the following experience:
            </p>
            <div className="ib-gft-modal-badge">
              ⛵ {selectedYacht.name} ({selectedYacht.guests})
            </div>
            <button 
              className="ib-gft-btn" 
              onClick={() => setShowGiftModal(false)}
            >
              Continue to Voucher Customization
            </button>
          </div>
        </div>
      )}

    </section> */}

    <section className="ib-gftfrm-section">
     
      <div className="ib-gftfrm-container">
        
        {/* Section Header */}
        <div className="ib-gftfrm-header">
          
          <h2 className="ib-gftfrm-main-title">Craft a Custom Yacht Experience Voucher</h2>
          
        </div>

        {/* Form Area */}
        <div className="ib-gftfrm-card">
          <form onSubmit={handleSubmit}>
            <div className="ib-gftfrm-grid">
              
              {/* Recipient Name */}
              <div>
                <label className="ib-gftfrm-label" htmlFor="recipientName">
                  Recipient Name *
                </label>
                <input
                  type="text"
                  id="recipientName"
                  name="recipientName"
                  required
                  placeholder="e.g. Rahul Sharma"
                  className="ib-gftfrm-input"
                  value={formData.recipientName}
                  onChange={handleInputChange}
                />
              </div>

              {/* Your Name */}
              <div>
                <label className="ib-gftfrm-label" htmlFor="yourName">
                  Your Name *
                </label>
                <input
                  type="text"
                  id="yourName"
                  name="yourName"
                  required
                  placeholder="e.g. Ananya Roy"
                  className="ib-gftfrm-input"
                  value={formData.yourName}
                  onChange={handleInputChange}
                />
              </div>

              {/* Occasion Selection */}
              <div className="ib-gftfrm-field-full">
                <label className="ib-gftfrm-label">
                  Select Occasion *
                </label>
                <div className="ib-gftfrm-occasions">
                  {occasions.map((occ) => (
                    <button
                      type="button"
                      key={occ}
                      className={`ib-gftfrm-occ-btn ${formData.occasion === occ ? 'active' : ''}`}
                      onClick={() => handleOccasionSelect(occ)}
                    >
                      {occ}
                    </button>
                  ))}
                </div>
              </div>

              {/* Gift Message */}
              <div className="ib-gftfrm-field-full">
                <label className="ib-gftfrm-label" htmlFor="giftMessage">
                  Personal Gift Message *
                </label>
                <textarea
                  id="giftMessage"
                  name="giftMessage"
                  required
                  placeholder="Write a special note to make this yacht journey unforgettable..."
                  className="ib-gftfrm-textarea"
                  value={formData.giftMessage}
                  onChange={handleInputChange}
                ></textarea>
              </div>

            </div>

            {/* Action Buttons */}
            <div className="ib-gftfrm-actions">
              <button
                type="button"
                className="ib-gftfrm-btn-preview"
                onClick={handlePreview}
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                  <circle cx="12" cy="12" r="3"></circle>
                </svg>
                Preview Voucher
              </button>

              <button
                type="submit"
                className="ib-gftfrm-btn-submit"
              >
                Submit & Proceed
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                  <polyline points="12 5 19 12 12 19"></polyline>
                </svg>
              </button>
            </div>
          </form>

          {/* Submission Success Confirmation */}
          {isSubmitted && (
            <div className="ib-gftfrm-success">
              <h3 className="ib-gftfrm-success-title">Voucher Customization Complete!</h3>
              <p className="ib-gftfrm-success-text">
                Your personalized gift details for <strong>{formData.recipientName || 'your recipient'}</strong> have been saved. Proceeding to final payment setup...
              </p>
            </div>
          )}
        </div>

      </div>

      {/* Voucher Live Preview Modal */}
      {showVoucherPreview && (
        <div className="ib-gftfrm-modal-overlay" onClick={() => setShowVoucherPreview(false)}>
          <div className="ib-gftfrm-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="ib-gftfrm-modal-close" onClick={() => setShowVoucherPreview(false)}>
              &times;
            </button>

            {/* Simulated Digital Voucher Ticket */}
            <div className="ib-vchr-card">
              <div className="ib-vchr-header">
                <span className="ib-vchr-brand">INDIABOATS</span>
                <span className="ib-vchr-tag">{formData.occasion || 'Special Experience'}</span>
              </div>

              <div className="ib-vchr-body">
                <div className="ib-vchr-to-from">
                  <div>
                    <span className="ib-vchr-meta-label">Prepared For</span>
                    <div className="ib-vchr-meta-val">{formData.recipientName || 'Recipient Name'}</div>
                  </div>
                  <div>
                    <span className="ib-vchr-meta-label">Gifted By</span>
                    <div className="ib-vchr-meta-val">{formData.yourName || 'Your Name'}</div>
                  </div>
                </div>

                <div className="ib-vchr-msg-box">
                  <span className="ib-vchr-meta-label">Personal Message</span>
                  <p className="ib-vchr-msg-quote">
                    "{formData.giftMessage || 'Wishing you an unforgettable luxury sailing experience on the water with Indiaboats!'}"
                  </p>
                </div>
              </div>

              <div className="ib-vchr-footer">
                <div>
                  <span className="ib-vchr-code-label">Voucher Reference</span>
                  <div className="ib-vchr-code">IB-GFT-2026-X89</div>
                </div>
                <div className="ib-vchr-validity">
                  Valid for 1 Year<br />Mumbai & Goa Charters
                </div>
              </div>
            </div>

            <div className="ib-vchr-modal-actions">
              <button
                className="ib-gftfrm-btn-submit"
                onClick={() => setShowVoucherPreview(false)}
                style={{ padding: '12px 24px', flex: 'none' }}
              >
                Close Preview
              </button>
            </div>
          </div>
        </div>
      )}

    </section>

      <Footer />
    </>
  );
};

export default Gift;
